module.exports = __webpack_public_path__ + "768d7fba5893f519bf1942c76906b602.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/enterprise_h128.png
// module id = 318
// module chunks = 1